"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEventListener = useEventListener;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useEventListener(eventKey, callback, // On SSR, document may not be defined at all
target = typeof document !== 'undefined' ? document : undefined) {
  // Store callback in a ref so we don't have to remove/add the event listener when callback changes
  const callbackRef = React.useRef(callback);
  React.useEffect(() => {
    callbackRef.current = callback;
  }, [callback]); // We have a conditional return for the cleanup function in this specific case,
  // we can safely disable this rule.
  // eslint-disable-next-line consistent-return

  React.useEffect(() => {
    const handler = event => callbackRef.current(event);

    if (target) {
      target.addEventListener(eventKey, handler);
      return () => {
        target.removeEventListener(eventKey, handler);
      };
    }
  }, [target, eventKey]);
}